import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import {
  IDataSourceRequest,
  IDataSourceResult,
  Academy,
  CreateUpdateAcademy,
  ProgramReservation,
} from '../models';
import { HelperService } from './helper.service';

@Injectable({ providedIn: 'root' })
export class ProgramReservationService {
  url = '/programs/reservations';
  request: IDataSourceRequest;

  constructor(private apiService: ApiService, private helperService: HelperService) {
    this.request = Object.assign({}, this.helperService.request);
  }

  get(): Observable<IDataSourceResult<ProgramReservation>> {
    return this.apiService.post(`${this.url}/search`, this.request).pipe(map(data => data.data));
  }

  getById(id: number): Observable<ProgramReservation> {
    return this.apiService.get(`${this.url}/${id}`).pipe(map(data => data.data));
  }

  exportProgramReservationExcel(): Observable<any> {
    return this.apiService
      .postWithReponseArrayBuffer(`${this.url}/export-program-reservation-excel/`, this.request)
      .pipe(map(data => data));
  }
}
